export default "__VITE_ASSET__kLztIqFU__"